module.exports = __webpack_public_path__ + "static/media/highlights_builder_sales.3d9749d7.png";